// extracted by mini-css-extract-plugin
module.exports = {"divider":"IonSelectDivider_divider__3GPT3"};